var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIkCheckSurcharge = function SvgIkCheckSurcharge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.526,
    height: 47.528
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.845 34.749a22.007 22.007 0 0 1-19.082 11.029A22.013 22.013 0 0 1 1.75 23.765 22.013 22.013 0 0 1 23.763 1.75a21.936 21.936 0 0 1 14.816 5.733 21.959 21.959 0 0 1 7.2 16.282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.259 18.854 22.098 30.017l-7.439-7.442"
  }))));
};
export default SvgIkCheckSurcharge;